import { InfoIcon } from 'components/icons/Info'
import type { BreakoutTooltipProps } from './BreakoutTooltip'
import { BreakoutTooltip } from './BreakoutTooltip'
import classNames from 'classnames'

/**
 * Renders a InfoIcon component wrapped in a tooltip component
 */
export function BreakoutInfoTooltip({
  iconSize = 14,
  kind = 'default',
  iconClassName,
  label,
  ...rest
}: Omit<BreakoutTooltipProps, 'children'> & {
  iconSize?: number
  kind?: 'default' | 'accent'
  label?: React.ReactNode
  iconClassName?: string
}) {
  return (
    <BreakoutTooltip {...rest}>
      <div
        className={classNames(
          'inline-flex items-center gap-1',
          rest.enabled === false ? 'cursor-not-allowed' : 'cursor-pointer'
        )}
      >
        {label}
        <span>
          <InfoIcon
            size={iconSize}
            className={classNames(
              kind === 'accent' && 'text-fixed-accent-color',
              iconClassName
            )}
          />
        </span>
      </div>
    </BreakoutTooltip>
  )
}
